/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

export default class Lead extends Entity {
  initialize() {
    this.url = '/lead';
  }

  defaults() {
    return {
      first_name: '',
      last_name: '',
    };
  }

  getFirstName(): ?string {
    return this.get('first_name');
  }

  getLastName(): ?string {
    return this.get('last_name');
  }

  getOrganizationId(): number {
    return this.get('organization_id');
  }

  getDisplayName() {
    return this.get('display_name');
  }

  getInitials() {
    return this.get('initials');
  }

  getColor() {
    return this.get('color');
  }

  hasBeenInvited(): boolean {
    return this.get('invited');
  }

  static delete() {
    return apiRequest('/lead', 'DELETE');
  }
}



// WEBPACK FOOTER //
// ./src/entities/Lead.js